import React, { useEffect, useContext } from 'react';
import { Box, Typography, Modal, IconButton, Grid } from '@mui/material';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CloseIconIMG from '../../images/Icon.svg';
import errorModal from '../../images/errorModal.svg';
import { BundleErrorModalStyles as classes } from './BundleErrorModalStyles';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import { CloseIcon } from '../../images/svg/CustomizedSVG';
import { useFlowContext } from '../commonCode';

function BundleErrorModal(props) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const leadGenerationContext = useContext(LeadGenerationContext);
  const baseContext = useFlowContext();
  const { theme } = baseContext;
  const { openModal, message, setIsModal } = props;
  const { errorHead, errorTitle, errorDescription } = message;

  const handleClose = () => {
    if (baseContext?.openProductQuestionModal) {
      baseContext.setOpenProductQuestionModal(false);
    }
    if (typeof setIsModal === 'function') {
      setIsModal(false);
    }
    setOpen(false);
  };

  useEffect(() => {
    if (openModal) setOpen(true);
    else setOpen(false);
  }, [openModal]);

  return (
    <Modal
      disableScrollLock
      sx={classes.backdrop}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'rgba(233, 233, 235, 0.78)' },
        },
      }}
      open={open}
      role="dialog"
      aria-describedby="dialog1Desc dialog2Desc"
    >
      <Box component="div" sx={{ ...classes.productmodal, background: theme?.customBackground }}>
        <Grid container sx={classes.productmodalcontainer}>
          <IconButton
            src={CloseIconIMG}
            name="closeicon"
            onClick={handleClose}
            tabIndex="0"
            data-testid="close_id"
            id="businessAddressEdit"
            disableRipple
          >
            <CloseIcon height="30px" width="30px" color={theme?.palette?.orientalPrimary?.main} />
          </IconButton>
        </Grid>
        <Grid container sx={classes.contentContainer}>
          {errorHead && (
            <>
              <Box component="img" src={errorModal} height="83px" width="151px" alt="errorImg" />
              <Typography sx={classes.errorHead} id="dialog1Desc">
                {t(errorHead, { defaultValue: errorHead })}
              </Typography>
            </>
          )}
          {errorTitle && (
            <Typography
              sx={{ ...classes.errorTitle, color: theme?.palette?.primary?.main }}
              id="dialog1Desc"
            >
              {t(errorTitle, { defaultValue: errorTitle })}
            </Typography>
          )}
          {errorDescription && (
            <Typography
              sx={{ ...classes.errorDescription, color: theme?.palette?.subtext?.main }}
              id="dialog1Desc"
            >
              {t(errorDescription, { defaultValue: errorDescription })}
            </Typography>
          )}
        </Grid>
      </Box>
    </Modal>
  );
}

BundleErrorModal.propTypes = {
  openModal: PropTypes.bool,
  message: PropTypes.object.isRequired,
  setIsModal: PropTypes.func,
};

export default withRouter(BundleErrorModal);
